import { services } from '../data/site';

export default function Services() {
  return (
    <section className="section services" id="services">
      <div className="container">
        <div className="services-top"><span className="eyebrow">HOW WE CAN HELP</span><a className="text-link" href="#service-details">View All Services <span aria-hidden="true">→</span></a></div>
        <div className="services-grid" id="service-details">
          <div className="services-intro"><h2>Support for Every Step of the Journey.</h2><p>Discover how Minrose can support children and families through their development journey.</p></div>
          {services.map((service, index) => <article className="service-card" key={service.title} id={`service-${index + 1}`}>
            <img src={service.image} alt={`${service.title} at Minrose`} loading="lazy" width="440" height="240" />
            <div className="service-body"><h3>{service.title}</h3><p>{service.description}</p><a className="text-link" href={`#contact`} aria-label={`Enquire about ${service.title}`}>Learn More <span aria-hidden="true">→</span></a></div>
          </article>)}
        </div>
      </div>
    </section>
  );
}